import { ModelFactory } from "../../../ModelFactory";

export class PHPInfo {
  constructor(
    public readonly phpVersions: string[],
  ) {
  }
}

class PHPInfoFactory extends ModelFactory<PHPInfo> {
  protected fromJson(json: any): PHPInfo {
    return new PHPInfo(
      json['php_versions'],
    );
  }
}
export const phpInfoFactory = new PHPInfoFactory();
